import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SilobagTagsListPayload, SilobagTagsListResponse } from './silobag-tags-list.types';
import { transformIntoQueryParamString } from '@old/utils/service';

// ✅ Implementado
export async function silobagTagsListService({ query: rawQuery }: SilobagTagsListPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<SilobagTagsListResponse>(ENDPOINT.ORGANIZATION_TAGS_V2, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
